import { InfoCircle } from "@liftedcare/solidjs-untitled-icons/duocolor";
import { JSX, ParentComponent, Show } from "solid-js";

import { useForm } from "../form/FormContext.js";
import { FormLabel } from "../form/FormLabel.js";
import Tooltip from "./Tooltip.js";

export interface FormRowProps {
  label: string | JSX.Element;
  subLabel?: string | JSX.Element;
  name?: string;
  containerClass?: string;
  labelClass?: string;
  inputClass?: string;
  inline?: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

const FormRow: ParentComponent<FormRowProps> = (props) => {
  const formContext = useForm();
  const errors = () => (props.name ? formContext?.getErrors(props.name) : null);
  const disabled = () => Boolean(props.disabled && props.disabledReason);
  return (
    <div
      class={`${props.containerClass} grid w-full grid-cols-1 items-center gap-x-4 border-b px-8 py-4`}
      classList={{
        "lg:grid-cols-3": props.inline === undefined || props.inline,
      }}
    >
      <div class={`flex flex-col ${props.labelClass}`}>
        <Tooltip message={props.disabledReason} enabled={disabled()}>
          <FormLabel
            class={`${
              props.subLabel
                ? `text-lg font-semibold ${props.labelClass} ${props.disabled ? "!text-gray-300" : ""}`
                : `${props.labelClass} ${props.disabled ? "!text-gray-300" : ""}`
            }`}
          >
            <span class="flex items-center gap-1">
              {props.label}
              <Show when={props.disabled && props.disabledReason}>
                <InfoCircle class="w-4 cursor-pointer text-blue-500" />
              </Show>
            </span>
          </FormLabel>
        </Tooltip>
        <Show when={props.subLabel}>
          <div
            class={`text-sm ${props.disabled ? "text-gray-300" : "text-gray-500"}`}
          >
            {props.subLabel}
          </div>
        </Show>
      </div>

      <div class={`${props.inputClass} w-full text-gray-500 lg:col-span-2`}>
        {props.children}
      </div>
      <Show when={errors()?.length}>
        <p
          class="text-sm text-error-500"
          classList={{
            "lg:col-span-2 lg:col-start-2":
              props.inline === undefined || props.inline,
          }}
        >
          {errors()}
        </p>
      </Show>
    </div>
  );
};

export default FormRow;
